import * as React from 'react';
import { MouseEvent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Prompt, withRouter } from 'react-router-dom';

import { history } from '../../ConfigureStore';
import { LoginDTO } from '../../Domain/DTO/LoginDTO';
import { VolmaContainer } from '../../Infrastructure/InversifyInject';
import { PASSWORD_RESET } from '../../Infrastructure/Router/RouterConstants';
import { RouterService } from '../../Infrastructure/Router/RouterService';
import { volmaBlock } from '../../Infrastructure/Services/BEM';
import PropertyHelper from '../../Infrastructure/Services/PropertyHelper';
import { Types } from '../../Infrastructure/Types';
import { BaseValidator } from '../../Infrastructure/Validation/BaseValidator';
import { NonEmptyTextValidator } from '../../Infrastructure/Validation/NonEmptyTextValidatorValidator';
import { IGlobalState } from '../../Reducers/IGlobalState';
import i18next from '../i18n';
import { VolmaComponent } from '../Shared/VolmaComponent';
import VolmaForm from '../VolmaForm';
import VolmaInput from '../VolmaInput';
import { IVolmaInputProps } from '../VolmaInput/IVolmaInputProps';
import { ILoginProps } from './ILoginProps';
import { LoginActions } from './LoginActions';

class Login extends VolmaComponent<ILoginProps> {
    public props: ILoginProps;

    private _loginActions: LoginActions;
    private _inputValidator: BaseValidator<IVolmaInputProps>;
    private _routerService: RouterService;

    private _modal       = volmaBlock("modal");
    private _modalWrap   = volmaBlock("modal-wrap");
    private _modalCont   = volmaBlock("modal-cont");
    private _modalLogin  = volmaBlock("modal-login");
    private _modalChange = volmaBlock("modal-change");
    private _lightInput  = volmaBlock("light-input");
    private _btnModal    = volmaBlock("btn-modal");

    constructor(props: ILoginProps, context: any) {
        super(props, context);

        this._inputValidator = VolmaContainer.get<NonEmptyTextValidator>(Types.NonEmptyTextValidator);
        this._loginActions = VolmaContainer.get<LoginActions>(Types.LoginActions);
        this._routerService = VolmaContainer.get<RouterService>(Types.RouterService);

        this.OnSubmit = this.OnSubmit.bind(this);
        super.SetActions(this._loginActions);
    }

    public UNSAFE_componentWillMount() {
        super.UNSAFE_componentWillMount();
        this.props.dispatch(this._actions.LoadData(new LoginDTO()))
    }


    render() {
        if (this.props.DataDTO === undefined)
            return <span></span>;
        return (
            <div className={(this._modal({login: true }).mix("active")).toString()}>
                <a className={(this._modal("logo")).toString()}>
                    <div className={(this._modal("logo-img")).toString()} ></div>
                </a>
                <div className={(this._modalWrap({cont: true })).toString()}>
                    <div className={(this._modalCont()).toString()}>
                        <span className={(this._modalCont("title")).toString()}>{i18next.t("login:Title")}</span>
                        <VolmaForm {...this.props as any} ClassName={(this._modalLogin()).toString()}>
                            <div className={(this._modalLogin("row")).toString()}>
                                <VolmaInput
                                    {...PropertyHelper.GetInputPropertyByName(this.props.Inputs, (val: LoginDTO) => val.Username) }
                                    Name={PropertyHelper.GetPropertyName((val: LoginDTO) => val.Username)}
                                    Label={i18next.t('login:Username')}
                                    Value={this.props.DataDTO.Username}
                                    Validator={this._inputValidator}
                                    dispatch={this.props.dispatch}
                                />
                            </div>
                            <div className={(this._modalLogin("row")).toString()}>
                                <VolmaInput
                                    {...PropertyHelper.GetInputPropertyByName(this.props.Inputs, (val: LoginDTO) => val.Password) }
                                    Name={PropertyHelper.GetPropertyName((val: LoginDTO) => val.Password)}
                                    Label={i18next.t('login:Password')}
                                    Value={this.props.DataDTO.Password}
                                    Type="password"
                                    Validator={this._inputValidator}
                                    dispatch={this.props.dispatch}
                                />
                            </div>
                            <div className={(this._modalLogin("row")).toString()}>
                                <button onClick={this.OnSubmit} className={(this._btnModal({large: true, green: true }).mix(["btn"])).toString()}>{i18next.t("login:LogIn")}</button>
                            </div>
                        </VolmaForm>
                        <div className={(this._modalChange()).toString()}>
                            <a onClick={this.OnPasswordReset.bind(this)} className={(this._modalChange("link")).toString()}>
                                <svg className={(this._modalChange("link-ico").mix("modal-key-ico")).toString()}>
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#key"></use>
                                </svg>
                                <span className={(this._modalChange("link-text")).toString()}>{i18next.t("login:ForgotYourPassword")}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>            
        );
    }

    protected RouterWillLeave() {
        return true;
    }

    private OnPasswordReset(){
        history.push(this._routerService.GetPathname(PASSWORD_RESET));
    }

    protected OnSubmit(evt: MouseEvent<HTMLButtonElement>) {
        super.OnSubmit(evt);
        if (this.props.IsValid) {
            this.props.dispatch(this._loginActions.DoLogin(this.props.DataDTO, i18next.t('common:WaitingForTheServer')))
        }
    }

}

const translated = withTranslation(['common'])(withRouter(Login));

function select(state: IGlobalState, ownProps: ILoginProps): ILoginProps {
    return state.Login;
}

let connectedLogin = connect<ILoginProps, {}, {}>(select)(translated);
export default connectedLogin;
